const statutoryRecords = [
  {
    id: "registrationDocuments",
    parentCategory: "minuteBook",
    label: "Registration Documents",
    disabled: true,
  },
  {
    id: "incorporationForms",
    label: "Incorporation Forms",
    parentCategory: "minuteBook",
    disabled: true,
  },
  {
    id: "statutoryFilings",
    label: "Statutory Filings",
    parentCategory: "minuteBook",
    disabled: true,
  },
  {
    id: "trademarks",
    label: "Trademarks",
    parentCategory: "minuteBook",
    disabled: true,
  },
];

const PartnersResolutionsAndConsents = [
  {
    id: "partnersResolution",
    parentCategory: "PartnersResolutionsAndConsents",
    label: "Partner Resolution",
    disabled: true,
  },
  {
    id: "partnersConsents",
    parentCategory: "PartnersResolutionsAndConsents",
    label: "Partner Consents",
    disabled: true,
  },
];

const ManagerResolutionsAndConsents = [
  {
    id: "partnerResolutions",
    parentCategory: "statutoryRegisters",
    label: "Partner Resolutions",
    disabled: true,
  },
  {
    id: "partnerCommitteesResolution",
    parentCategory: "statutoryRegisters",
    label: "Partner Committee's Resolutions",
    disabled: true,
  },
  {
    id: "partnerConsentAgreements",
    parentCategory: "statutoryRegisters",
    label: "Partner Consent Agreements",
    disabled: true,
  },
];

const statutoryRegisters = [
  {
    id: "registerOfMembers",
    parentCategory: "statutoryRegisters",
    label: "Register of Members",
    disabled: true,
  },
  {
    id: "registerOfMembersResidences",
    label: "Register of Members'Residences",
    parentCategory: "statutoryRegisters",
    disabled: true,
  },
  {
    id: "registerOfAuthorizedPersons",
    label: "Register of Authorized Persons",
    parentCategory: "statutoryRegisters",
    disabled: true,
  },
  {
    id: "registerOfPartners",
    label: "Register of Partners",
    parentCategory: "statutoryRegisters",
    disabled: true,
  },
  {
    id: "registerOfBeneficialOwners",
    parentCategory: "statutoryRegisters",
    label: "Register of Beneficial Owners",
    disabled: true,
  },
  {
    id: "registerOfChangesMortgages",
    label: "Register of Changes/Mortgages",
    parentCategory: "statutoryRegisters",
    disabled: true,
  },
  {
    id: "registerOfDebentures",
    label: "Register of Debentures",
    parentCategory: "statutoryRegisters",
    disabled: true,
  },
];

export const minuteBookSidebarItems = [
  {
    id: "statutoryRecords",
    label: "Statutory Records",
    renderMinuteBook: true,
    children: statutoryRecords,
  },
  {
    id: "PartnersResolutionsAndConsents",
    label: "Partner Resolutions and Consents",
    children: PartnersResolutionsAndConsents,
  },
  {
    id: "ManagerResolutionsAndConsents",
    label: "Manager Resolutions and Consents",
    children: ManagerResolutionsAndConsents,
  },
  {
    id: "statutoryRegisters",
    label: "Statutory Registers",
    children: statutoryRegisters,
  },
  // {
  //   id: "shareCertificates",
  //   label: "Share Certificates",
  //   prevRegister: "registerOfBeneficialOwners",
  //   renderMinuteBook: true,
  //   breadCrumbs: [
  //     {
  //       id: "minuteBook",
  //       label: "Minute Book",
  //       disabled: true,
  //     },
  //     {
  //       id: "minuteBook",
  //       label: "Share Certificates",
  //       parentCategory: "minuteBook",
  //       disabled: true,
  //     },
  //   ],
  // },
  {
    id: "agreementsAndContracts",
    label: "Agreements & Contracts",
    disabled: true,
  },
  {
    id: "policies",
    label: "Policies",
    disabled: true,
  },
  {
    id: "History",
    label: "History",
    disabled: true,
  },
];
